module.exports = __webpack_public_path__ + "img/alabama-power-logo.dcb35607.jpg";